import { connect } from "react-redux";

import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { CandyDispatch } from "../../../Engine/Core/Store/CandyReduxTypes";
import { cancelImportDocuments, submitImportDocument } from "../State/EmployerDocumentsActionCreators";
import { EmployerNormalizedTag } from "../../EmployeeServiceTypes";
import { EmployerDocumentsActionType } from "../State/EmployerDocumentsAction";
import { documentsToTagsListView } from "../DocumentsToTagsListView";

import { EmployerDocumentsSidePage } from "./EmployerDocumentsSidePage";

const mapStateToProps = (state: FullFormState) => ({
    showSideBar: state.employerDocuments?.showSideBar ?? false,
    loading: state.employerDocuments?.loading ?? false,
    options: state.employerDocuments?.options,
    documentTags: documentsToTagsListView(state.employerDocuments),
    activePage: state.employerDocuments?.activePage ?? 1,
});

const mapDispatchToProps = (dispatch: CandyDispatch) => ({
    onClose: () => dispatch(cancelImportDocuments()),
    onSubmit: (tag: EmployerNormalizedTag) => dispatch(submitImportDocument(tag)),
    onPageChange: (pageNumber: number) =>
        dispatch({
            type: EmployerDocumentsActionType.ChangePage,
            payload: {
                pageNumber: pageNumber,
            },
        }),
});

export const EmployerDocumentsContainer = connect(mapStateToProps, mapDispatchToProps)(EmployerDocumentsSidePage);
